<template>
  <PageContainer id="motivation-science">
    <div class="page-content">
      <div class="title">Motivation Science</div>
      <div class="title small black">People who bet were 5X more likely to hit goal</div>

      <p class="info">in a randomized, controlled study published in the Journal of the American Medical Association.<sup>1</sup></p>

      <img class="motivation_science_img" :src="scienceImg" alt="an image about a study" />

      <div>
        <p>
          <sup>1</sup> Citation: JAMA. 2008 Dec 10; 300(22): 2631-2637.
          <br />doi: 10.1001/jama.2008.804
        </p>
      </div>

    </div>

    <div class="footer-container">
      <ButtonNext :onClick="next" :isDisabled="false" :text="'Next'" />
      <ProgressBar />
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '../../shared/components/PageContainer';
import ButtonNext from '../../shared/components/ButtonNext';
import ProgressBar from '../../shared/components/ProgressBar';
import { STATIC_URL } from '../main';
import Trackeable from '../../Trackeable';
import ProgressFull from '../mixins/ProgressFull';
import { navigateTo, ROUTE_NAMES } from '../router';

export default {
  components: {
    PageContainer,
    ButtonNext,
    ProgressBar
  },
  mixins: [Trackeable, ProgressFull],
  data() {
    return {
      scienceImg: `${STATIC_URL}img/funnel-v4/people_who_bet.png`
    }
  },
  methods: {
    next() {
      navigateTo(this.$router, ROUTE_NAMES.WeightLossProgramTried3)
    }
  }
}
</script>
